export default {"src":"/_next/static/media/IE.ed43f285.svg","height":355,"width":512,"blurWidth":0,"blurHeight":0};